var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecoveryConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 12.5799V15.3099C14.6 17.5899 13.69 18.4999 11.41 18.4999H8.69C6.42 18.4999 5.5 17.5899 5.5 15.3099V12.5799C5.5 10.3099 6.41 9.3999 8.69 9.3999H11.42C13.69 9.3999 14.6 10.3099 14.6 12.5799Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5004 8.68V11.41C18.5004 13.69 17.5904 14.6 15.3104 14.6H14.6004V12.58C14.6004 10.31 13.6904 9.4 11.4104 9.4H9.40039V8.68C9.40039 6.4 10.3104 5.5 12.5904 5.5H15.3204C17.5904 5.5 18.5004 6.41 18.5004 8.68Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15C22 18.87 18.87 22 15 22L16.05 20.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 5.13 5.13 2 9 2L7.95 3.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryConvert);
export default __webpack_public_path__ + "static/media/recovery-convert.5ca4147a8aa15676cfc4990d70eefe51.svg";
export { ForwardRef as ReactComponent };